var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4278_11587"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    fillOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4278_11587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 5.83C14.9 5.83 15.59 5.83 16.13 6.1C16.6 6.34 16.98 6.72 17.22 7.19C17.38 7.49 17.44 7.85 17.47 8.35C17.5 8.74 17.5 9.22 17.5 9.83L17.5 13.5C17.5 14.9 17.5 15.6 17.22 16.13C16.98 16.6 16.6 16.98 16.13 17.22C15.59 17.5 14.9 17.5 13.5 17.5L6.5 17.5C5.09 17.5 4.4 17.5 3.86 17.22C3.39 16.98 3.01 16.6 2.77 16.13C2.5 15.6 2.5 14.9 2.5 13.5L2.5 9.83C2.5 9.22 2.5 8.74 2.52 8.35C2.55 7.85 2.61 7.49 2.77 7.19C3.01 6.72 3.39 6.34 3.86 6.1C4.4 5.83 5.09 5.83 6.5 5.83L13.5 5.83ZM6.66 5.83L6.66 5.16C6.66 4.23 6.66 3.76 6.84 3.41C7 3.09 7.26 2.84 7.57 2.68C7.93 2.5 8.4 2.5 9.33 2.5L10.66 2.5C11.59 2.5 12.06 2.5 12.42 2.68C12.73 2.84 12.99 3.09 13.15 3.41C13.33 3.76 13.33 4.23 13.33 5.16L13.33 5.83M17.47 8.35C17.17 8.64 13.92 11.66 10 11.66C6.07 11.66 2.82 8.64 2.52 8.35",
    stroke: "#FFFFFF",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/organization.1d6627ec6aa548ab41a123e050dcf2ca.svg";
export { ForwardRef as ReactComponent };